import { FC } from "react";

import Box, { BoxProps } from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import Heading from "sections/nfcTagsPage/Heading";

import ImageNext from "components/ImageNext";

import styles from "./styles";

interface OpportunitiesSectionProps {
  boxProps?: BoxProps;
}

const OpportunitiesSection: FC<OpportunitiesSectionProps> = ({ boxProps }) => {
  return (
    <Box component="section" display="grid" {...boxProps}>
      <Heading
        heading="New opportunities
for your brand"
        subheading="Give your users a pass to the whole new benefits of owning your items. Get endless possibilities of interacting with the brand."
      />

      <Box sx={styles.container}>
        <ImageNext
          src={`${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/nfcTagsPage/opportunities/logo.png`}
          width={532}
          height={297}
          alt=""
          style={{
            width: "100%",
            maxWidth: 350,
            objectFit: "contain",
            margin: "0 auto 20px",
            height: "auto",
          }}
        />

        <Box sx={styles.contentOuter}>
          <Box sx={styles.content}>
            <Typography
              variant="h1"
              component="h3"
              sx={[styles.text, styles.overflowText]}
            >
              Unforgettable Experience
              <br />
              Proven Ownership <Box component="span" sx={styles.textSpace} />
              Authentication
              <br />
              Interactivity <Box component="span" sx={styles.textSpace} />
              Innovation
              <br />
              Exclusivity <Box component="span" sx={styles.textSpace} />
              Traceable item history
              <br />
              New marketing opportunities
            </Typography>

            <Box sx={styles.itemBox} aria-hidden="true">
              <Box sx={styles.item}>
                <Typography
                  variant="h1"
                  component="p"
                  sx={[styles.text, styles.strokeText]}
                >
                  Unforgettable Experience
                  <br />
                  Proven Ownership{" "}
                  <Box component="span" sx={styles.textSpace} />
                  Authentication
                  <br />
                  Interactivity <Box component="span" sx={styles.textSpace} />
                  Innovation
                  <br />
                  Exclusivity <Box component="span" sx={styles.textSpace} />
                  Traceable item history
                  <br />
                  New marketing opportunities
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default OpportunitiesSection;
